module.exports = __webpack_public_path__ + "img/16581278_L.0e44be2a.png";